import InvoiceContainer from "../../Componant/Ecommerce/Invoice";

const Invoice = () => {
  return (
    <div className="page-body">
      <InvoiceContainer />
    </div>
  );
};

export default Invoice;
